import { render } from "./EditIncident.vue?vue&type=template&id=b061b7d0&ts=true"
import script from "./EditIncident.vue?vue&type=script&lang=ts"
export * from "./EditIncident.vue?vue&type=script&lang=ts"

import "./EditIncident.vue?vue&type=style&index=0&id=b061b7d0&lang=css"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__